// extracted by mini-css-extract-plugin
export default {"tabLabel":"GoodsTab_tabLabel__xMLsA","customTabBar":"GoodsTab_customTabBar__r1CCV"};